module.exports = __webpack_public_path__ + "static/images/styles/images/events/event-building.74a27e6f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/events/event-building.png
// module id = 3624
// module chunks = 11